module.exports = __webpack_public_path__ + "static/media/app_screens_5.0414ef3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app_screens_5.png
// module id = 371
// module chunks = 0